import { messages, type Locale } from "@shared/i18n";
import type { OfferProfile } from "@shared/lib/offer-profiles-shared";

// Vue client d'une offre : ce que le sélecteur, la carte de veille et l'écran
// « Mes offres » ont besoin de savoir, sans aucune dépendance serveur
// (même rôle que lib/leads-shared.ts pour le pipeline).

export type OfferSummary = {
  id: string;
  url: string;
  /** Nom affichable : celui trouvé par l'agent, à défaut le domaine. */
  name: string;
  offerName: string | null;
  archivedAt: string | null;
  radarActive: boolean;
  /**
   * L'offre entre dans le plan du compte (non archivée, parmi les N plus
   * anciennes) : hors du plan, le radar ne la reprend pas, active ou non.
   */
  covered: boolean;
  /** Cadence effective de la veille : jamais sous le minimum du plan. */
  frequencyDays: number;
  /** Dernier passage, radar ou lancé à la main. */
  lastPassAt: string | null;
  /**
   * Réveil du radar qui reprendra l'offre (cadence effective, heure du radar) ;
   * null si la veille est en pause, hors du plan, ou si un passage lancé à la
   * main tourne (sa fin fixera la suite).
   */
  nextPassAt: string | null;
};

/** Une offre avec sa fiche de ciblage, pour l'écran « Mes offres ». */
export type OfferWithProfile = OfferSummary & { profile: OfferProfile };

export const DEFAULT_FREQUENCY_DAYS = 7;

export function hostOf(url: string) {
  try {
    return new URL(/^https?:\/\//i.test(url) ? url : `https://${url}`).host.replace(/^www\./, "");
  } catch {
    return url;
  }
}

/** Monitoring cadence inside a sentence ("chaque semaine", "every week"). */
export function cadenceLabel(days: number, locale: Locale = "fr") {
  const cadence = messages(locale).settings.cadence;
  return cadence.named[days] ?? cadence.everyDays(days);
}
